module.exports = __webpack_public_path__ + "static/ring_of_evasion-18f0e550ff7f22da10e1c380aca5f8c3.jpeg";